import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import { palette } from "../../../theme/palette";

import {
  depotSummaryInformation,
  volumeDataSelector,
  driverlessRoutesSelector,
  locationConfigSelector,
} from "../../../reducers/matrixProfile/selectors";

import { numberWithCommas } from "../../../utils/routes";

import { View } from "../../Base";
import DriverlessRoutesComponent from "../DriverlessRoutesComponent";
import UnallocatedLocationsComponent from "../UnallocatedLocationsComponent";
import KeyValue from "../KeyValue";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    marginLeft: "10px",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  clockIcon: {
    width: "16px",
    height: "16px",
  },
  warningIcon: {
    width: "16px",
    height: "14.45",
  },
  questionMarkIcon: {
    width: "16px",
    height: "16px",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const LocationsSummaryPanel = () => {
  const styles = useStyles();
  const depotSummaryInfo = useSelector(depotSummaryInformation);
  const volumeData = useSelector(volumeDataSelector);
  const locationConfig = useSelector(locationConfigSelector);
  const driverlessRoutes = useSelector(driverlessRoutesSelector);

  return (
    <View className={styles.container}>
      <KeyValue
        property={"Locations"}
        value={numberWithCommas(locationConfig?.length || 0)}
      />
      <KeyValue
        property={"Routes"}
        value={numberWithCommas(
          depotSummaryInfo?.timeBandFigures?.totalAllocated || 0
        )}
      />

      {volumeData && (
        <KeyValue
          property={"Planned Stops"}
          value={numberWithCommas(depotSummaryInfo?.plannedStops || 0)}
        />
      )}
      {volumeData && (
        <KeyValue
          property={"Planned Parcels"}
          value={numberWithCommas(depotSummaryInfo?.plannedParcels || 0)}
        />
      )}

      <UnallocatedLocationsComponent />
      <DriverlessRoutesComponent driverlessRoutes={driverlessRoutes} />
    </View>
  );
};

export default LocationsSummaryPanel;
